import { queryOptions } from '@tanstack/react-query';
import { PdpPhaseDTO } from '@/types/models';
import { client } from '@/api/client';
export const getPdpPhases = async (id: string): Promise<PdpPhaseDTO[]> => {
  try {
    const result = await client.get(`/plans/${id}/phases`);
    return result.data.data || [];
  } catch (error) {
    return [];
  }
};
export const pdpPhasesOptions = (id: string) => queryOptions({
  queryKey: ['pdp-phases', id],
  queryFn: () => getPdpPhases(id)
});